/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Button,
  IconButton,
  Toolbar,
  Hidden,
} from '@material-ui/core';

import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import MenuIcon from '@material-ui/icons/Menu';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { PricingModal, NotificationsPopover, SettingPopover } from 'components';
import useStyles from './style';

const TopBar = props => {
  const { onOpenNavBarMobile, notifications, roles, currentAccount, className, handleLogout, ...rest } = props;
  const notificationsRef = useRef(null);
  const settingRef = useRef(null);
  const classes = useStyles();
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);

  const handlePricingClose = () => {
    setPricingModalOpen(false);
  };

  const handleNotificationsOpen = () => {
    setOpenNotifications(true);
  };

  const handleNotificationsClose = () => {
    setOpenNotifications(false);
  };

  const handleSettingOpen = () => {
    setOpenSetting(true);
  };

  const handleSettingClose = () => {
    setOpenSetting(false);
  };



  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="inherit"
    >
      <Toolbar>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onOpenNavBarMobile}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <img
            alt="Logo"
            src="/images/logo.png"
          />
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          <IconButton
            className={classes.notificationsButton}
            color="inherit"
            onClick={handleNotificationsOpen}
            ref={notificationsRef}
          >
            <Badge
              badgeContent={notifications.length}
              classes={{ badge: classes.notificationsBadge }}
              variant="dot"
            >
              <NotificationsIcon/>
            </Badge>
          </IconButton>
          {roles && roles.length > 1 && <IconButton
            className={classes.notificationsButton}
            color="inherit"
            onClick={handleSettingOpen}
            ref={settingRef}
          >
            <SettingsOutlinedIcon />
          </IconButton>}
          <Button
            className={classes.logoutButton}
            color="inherit"
            onClick={handleLogout}
          >
            <InputIcon className={classes.logoutIcon} />
            Sign out
          </Button>
        </Hidden>
      </Toolbar>
      <PricingModal
        onClose={handlePricingClose}
        open={pricingModalOpen}
      />
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClose={handleNotificationsClose}
        open={openNotifications}
      />
      {currentAccount && roles && roles.length > 1 && <SettingPopover
        anchorEl={settingRef.current}
        roles={roles}
        onClose={handleSettingClose}
        open={openSetting}
        currentAccount={currentAccount}
      />}
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
  roles: PropTypes.array,
  notifications: PropTypes.array,
  currentAccount: PropTypes.any,
};

TopBar.defaultProps = {
  roles: [],
  notifications: [],
  currentAccount: null,
}

export default TopBar;
